var map = {
	"./playground.webp": 4834,
	"./projectBeforeExtension2.webp": 3525,
	"./projectBeforeWhole.webp": 2392,
	"./projectBeforeWhole5.webp": 7358,
	"./projectBeforeWork2.webp": 7578,
	"./projectBeforeWorkGrass.webp": 2987,
	"./projectGrass2.webp": 3229,
	"./projectGrass3.webp": 4528,
	"./projectStairs2.webp": 9397,
	"./shaunBeforeWhole.webp": 7007,
	"./shaunGrass2.webp": 2057,
	"./shaunSlide2.webp": 7799,
	"./shaunStairs.webp": 3789,
	"./shaunTrampoline.webp": 1542,
	"./shaunWhole5.webp": 2496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7434;